export enum ComprasEstado {
  Borrador,
  CotizacionSolicitada,
  CotizacionRecibida,
  PedidoRealizado,
  PedidoRecepcionado,
  Pagado,
  PedidoRecepcionadoParcial,
}

export const ComprasEstadoLabels: { [key in ComprasEstado]: string } = {
  [ComprasEstado.Borrador]: 'Borrador',
  [ComprasEstado.CotizacionSolicitada]: 'Cotizacion Solicitada',
  [ComprasEstado.CotizacionRecibida]: 'Cotizacion Recibida',
  [ComprasEstado.PedidoRealizado]: 'Pedido Realizado',
  [ComprasEstado.PedidoRecepcionado]: 'Pedido Recepcionado',
  [ComprasEstado.Pagado]: 'Pagada',
  [ComprasEstado.PedidoRecepcionadoParcial]: 'Recepción Parcial',
};

export const colorMapping: { [key in ComprasEstado]: string } = {
  [ComprasEstado.Borrador]: '#70BDFF',
  [ComprasEstado.CotizacionSolicitada]: 'orange',
  [ComprasEstado.CotizacionRecibida]: ' #e67300',
  [ComprasEstado.PedidoRealizado]: '#b35900',
  [ComprasEstado.PedidoRecepcionado]: '#654321',
  [ComprasEstado.Pagado]: '#237e18',
  [ComprasEstado.PedidoRecepcionadoParcial]: '#ffcc00',
};

export const getComprasEstado = () => {
  return Object.values(ComprasEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: ComprasEstadoLabels[id as ComprasEstado],
    }));
};
